import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';


@Injectable()
export class ExceptionService {

  constructor(
    private translateService: TranslateService
  ) { }


  public catchBadResponse(response): Observable<any> {
    let code;

    if (response instanceof HttpErrorResponse && response.error) {
      code = response.error.code;
    }

    if (response instanceof HttpErrorResponse && !code && response.message) {
      return throwError(response.message);
    }

    // TODO: Rethink where should be more convenient to add this conditional logic to display
    // the received message from the API instead of the mapped error message.
    if (code === 'BUS_1027' || code === 'BUS_1147') {
      return throwError(response.error.message);
    }

    return throwError(this.translateService.instant(`API_ERRORS.${code}`, { value: '' }));
  }
}
